import {GeospatialEntitySymbolType, SpatialEntityData} from '../../../../../pages/geospatial-viewer/model/api';
import {GeospatialTooltipType} from '../../../../../pages/geospatial-viewer/model/tooltip.model';
import {OutageEntityDto} from '../../../../../pages/geospatial-viewer/layers/outage-layer';
import {VisualizationType} from '../../../../../pages/geospatial-viewer/model/visualization';

export interface SpatialEntityDataExtended extends SpatialEntityData {
    tooltipType: GeospatialTooltipType;
    renderedVisualizationType: VisualizationType;
    metric?: string;
    projectName?: string;
}

export interface SpatialOutageEntityDataExtended extends OutageEntityDto {
    tooltipType: GeospatialTooltipType;
    renderedVisualizationType: VisualizationType;
}

export class EnginDataPrepareService {
    constructor() {}

    /**
     * Prepare data for point asset layer.
     * @return SpatialEntityDataExtended[]
     */
    public prepare(
        data: SpatialEntityData[],
        tooltipType: GeospatialTooltipType,
        visualizationType: VisualizationType,
    ): SpatialEntityDataExtended[] {
        return data.map((entity: SpatialEntityData) => {
            return {
                // Unique identifiers
                entityId: entity.entityId,
                entityType: entity.entityType,
                tooltipType: tooltipType,
                // Used for tooltips
                renderedVisualizationType: visualizationType,
                // Spatial data
                geoJsonGeometry: entity.geoJsonGeometryStr ? JSON.parse(entity.geoJsonGeometryStr) : null,
                // Data
                colour: entity.colour ? entity.colour : 'GREY',
                count: entity.count ? entity.count : 1,
                geospatialEntitySymbolType: entity.geospatialEntitySymbolType || GeospatialEntitySymbolType.POINT,
            };
        });
    }

    /**
     * Prepare data for point asset layer.
     * @return SpatialOutageEntityDataExtended[]
     */
    public prepareOutage(
        data: OutageEntityDto[],
        tooltipType: GeospatialTooltipType,
        visualizationType: VisualizationType,
    ): SpatialOutageEntityDataExtended[] {
        return data.map((entity: OutageEntityDto) => {
            return {
                // Unique identifier
                entityId: entity.entityId,
                entityType: entity.entityType,
                // Used for tooltips
                renderedVisualizationType: visualizationType,
                // Spatial data
                geoJsonGeometry: entity.geoJsonGeometryStr ? JSON.parse(entity.geoJsonGeometryStr) : null,
                centroidGeoJsonGeometry: entity.centroidGeoJsonStr ? JSON.parse(entity.centroidGeoJsonStr) : null,
                tooltipType: tooltipType,
                // Data
                colour: entity.colour ? entity.colour : 'METRIC_COLOUR1',
                label: entity.label ? entity.label : '',
            };
        });
    }
}
